import React from 'react';
import './index.scss';
import Const from './../Const';
import { connect } from 'react-redux';
import {
  changeBreakoutType,
  changeBreakoutMaType,
  changeMarketNormallyCheck,
  REDUCER_NAME,
} from '../reducer';
import { Translate } from 'react-redux-i18n';

class TopInfoStrategy extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      breakOutType: Const.filterBreakout.breakOutType.TOP,
      breakOutMaType: Const.filterBreakoutMa.breakOutType.CROSS_DOWN,
      checkboxMarketNormally: Const.filterMarketAbnormally.optionTime.Daily,
    };
  }

  selectCheckBoxBreakout(refCheckbox) {
    let breakOutType = Const.filterBreakout.breakOutType.TOP;
    if (refCheckbox === this.checkboxTop) {
      breakOutType = Const.filterBreakout.breakOutType.TOP;
      this.setState({
        ...this.state,
        breakOutType: Const.filterBreakout.breakOutType.TOP,
      });
    } else {
      breakOutType = Const.filterBreakout.breakOutType.BOTTOM;
      this.setState({
        ...this.state,
        breakOutType: Const.filterBreakout.breakOutType.BOTTOM,
      });
    }
    const { changeBreakoutType } = this.props;
    changeBreakoutType(breakOutType);
  }

  selectCheckBoxBreakoutMa(refCheckbox) {
    let breakOutMaType = Const.filterBreakoutMa.breakOutType.CROSS_DOWN;
    if (refCheckbox === this.checkboxCrossUp) {
      breakOutMaType = Const.filterBreakoutMa.breakOutType.CROSS_UP;
      this.setState({
        ...this.state,
        breakOutMaType: breakOutMaType,
      });
    } else {
      breakOutMaType = Const.filterBreakoutMa.breakOutType.CROSS_DOWN;
      this.setState({
        ...this.state,
        breakOutMaType: breakOutMaType,
      });
    }
    const { changeBreakoutMaType } = this.props;
    changeBreakoutMaType(breakOutMaType);
  }

  selectCheckBoxAnomaly(refCheckbox) {
    let checkboxMarketNormally = Const.filterMarketAbnormally.optionTime.Daily;
    if (refCheckbox === this.checkboxDaily) {
      checkboxMarketNormally = Const.filterMarketAbnormally.optionTime.Daily;
    }
    if (refCheckbox === this.checkboxMonthly) {
      checkboxMarketNormally = Const.filterMarketAbnormally.optionTime.Monthly;
    }

    if (refCheckbox === this.checkboxQuarterly) {
      checkboxMarketNormally =
        Const.filterMarketAbnormally.optionTime.Quarterly;
    }
    this.setState({
      ...this.state,
      checkboxMarketNormally: checkboxMarketNormally,
    });

    const { changeMarketNormallyCheck } = this.props;
    changeMarketNormallyCheck(checkboxMarketNormally);
  }

  getInfoCheckbox = () => {
    const { currentTab } = this.props;
    const breakOutType = this.props.filterData[2].breakOutType;
    const breakOutMaType = this.props.filterData[3].breakOutType;
    const checkboxMarketNormally = this.props.filterData[5]
      .checkboxMarketNormally;
    const map = {
      [Const.tabs.accummulation]: <div />,

      [Const.tabs.breakOut]: (
        <div style={{ height: 40, display: 'flex', marginLeft: 100 }}>
          <div
            className="checkbox check-box-font"
            style={{ padding: '0px 20px', cursor: 'default' }}
          >
            <input
              style={{ top: '0px', height: '0px' }}
              id="check"
              type="checkbox"
              checked={breakOutType === Const.filterBreakout.breakOutType.TOP}
              ref={input => (this.checkboxTop = input)}
              onChange={() => {}}
            />
            <label
              onClick={() => this.selectCheckBoxBreakout(this.checkboxTop)}
              style={{ position: 'relative', marginTop: 15 }}
              htmlFor="check"
            >
              <span className="text-white">
                <Translate value={`taStrategy.groupRadioButtonBreakOut.top`} />
              </span>
            </label>
          </div>

          <div
            className="checkbox check-box-font"
            style={{ padding: '0px 20px', cursor: 'default' }}
          >
            <input
              style={{ top: '0px', height: '0px' }}
              id="check"
              type="checkbox"
              checked={
                breakOutType === Const.filterBreakout.breakOutType.BOTTOM
              }
              ref={input => (this.checkboxBottom = input)}
              onChange={() => {}}
            />
            <label
              onClick={() => this.selectCheckBoxBreakout(this.checkboxBottom)}
              style={{ position: 'relative', marginTop: 15 }}
              htmlFor="check"
            >
              <span className="text-white">
                <Translate
                  value={`taStrategy.groupRadioButtonBreakOut.bottom`}
                />
              </span>
            </label>
          </div>
        </div>
      ),

      [Const.tabs.breakOutMa]: (
        <div style={{ height: 40, display: 'flex', marginLeft: 20 }}>
          <div
            className="checkbox"
            style={{ padding: '0px 20px', cursor: 'default' }}
          >
            <input
              style={{ top: '0px', height: '0px' }}
              id="check"
              type="checkbox"
              checked={
                breakOutMaType === Const.filterBreakoutMa.breakOutType.CROSS_UP
              }
              ref={input => (this.checkboxCrossUp = input)}
              onChange={() => {}}
            />
            <label
              onClick={() =>
                this.selectCheckBoxBreakoutMa(this.checkboxCrossUp)
              }
              style={{ position: 'relative', marginTop: 15 }}
              htmlFor="check"
            >
              <span className="text-white">
                <Translate
                  value={`taStrategy.groupRadioButtonBreakOutMa.crossUp`}
                />
              </span>
            </label>
          </div>

          <div
            className="checkbox"
            style={{ padding: '0px 20px', cursor: 'default' }}
          >
            <input
              style={{ top: '0px', height: '0px' }}
              id="check"
              type="checkbox"
              checked={
                breakOutMaType ===
                Const.filterBreakoutMa.breakOutType.CROSS_DOWN
              }
              ref={input => (this.checkboxCrossDown = input)}
              onChange={() => {}}
            />
            <label
              onClick={() =>
                this.selectCheckBoxBreakoutMa(this.checkboxCrossDown)
              }
              style={{ position: 'relative', marginTop: 15 }}
              htmlFor="check"
            >
              <span className="text-white">
                <Translate
                  value={`taStrategy.groupRadioButtonBreakOutMa.crossDown`}
                />
              </span>
            </label>
          </div>
        </div>
      ),

      [Const.tabs.bestInDowntrend]: <div />,

      [Const.tabs.marketAnomaly]: (
        <div style={{ height: 40, display: 'flex', marginLeft: 50 }}>
          <div
            className="checkbox"
            style={{ padding: '0px 20px', cursor: 'default' }}
          >
            <input
              style={{ top: '0px', height: '0px' }}
              id="check1"
              type="checkbox"
              checked={
                checkboxMarketNormally ===
                Const.filterMarketAbnormally.optionTime.Daily
              }
              ref={input => (this.checkboxDaily = input)}
              onChange={() => {}}
            />
            <label
              onClick={() => this.selectCheckBoxAnomaly(this.checkboxDaily)}
              style={{ position: 'relative', marginTop: 15 }}
              htmlFor="check1"
            >
              <span className="text-white">
                <Translate
                  value={`taStrategy.groupRadioButtonMarketAnomaly.daily`}
                />
              </span>
            </label>
          </div>

          <div
            className="checkbox"
            style={{ padding: '0px 20px', cursor: 'default' }}
          >
            <input
              style={{ top: '0px', height: '0px' }}
              id="check2"
              type="checkbox"
              checked={
                checkboxMarketNormally ===
                Const.filterMarketAbnormally.optionTime.Monthly
              }
              ref={input => (this.checkboxMonthly = input)}
              onChange={() => {}}
            />
            <label
              onClick={() => this.selectCheckBoxAnomaly(this.checkboxMonthly)}
              style={{ position: 'relative', marginTop: 15 }}
              htmlFor="check2"
            >
              <span className="text-white">
                <Translate
                  value={`taStrategy.groupRadioButtonMarketAnomaly.monthly`}
                />
              </span>
            </label>
          </div>

          <div
            className="checkbox"
            style={{ padding: '0px 20px', cursor: 'default' }}
          >
            <input
              style={{ top: '0px', height: '0px' }}
              id="check3"
              type="checkbox"
              checked={
                checkboxMarketNormally ===
                Const.filterMarketAbnormally.optionTime.Quarterly
              }
              ref={input => (this.checkboxQuarterly = input)}
              onChange={() => {}}
            />
            <label
              onClick={() => this.selectCheckBoxAnomaly(this.checkboxQuarterly)}
              style={{ position: 'relative', marginTop: 15 }}
              htmlFor="check3"
            >
              <span className="text-white">
                <Translate
                  value={`taStrategy.groupRadioButtonMarketAnomaly.quarterly`}
                />
              </span>
            </label>
          </div>
        </div>
      ),
    };

    return map[currentTab];
  };

  render() {
    const { infoStrategy } = this.props;
    let infoCheckbox = this.getInfoCheckbox();

    return (
      <div className="d-flex flex-shrink-0">
        <div className="wrap-strategy-info-strategy mb-10">
          <div
            className="box-icon-strategy"
            style={{ backgroundColor: `${infoStrategy.color}` }}
          >
            <a className="label-strategy text-white" href="#">
              {infoStrategy.summaryName}
            </a>
          </div>
          <div className="box-info-strategy">
            <span className="text-top-line">{infoStrategy.name}</span>
            <span className="text-bot-line">
              {infoStrategy.characteristics}
            </span>
          </div>
        </div>

        {infoCheckbox}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  i18n: state.i18n,
  filterData: state[REDUCER_NAME].filterData,
});

const mapDispatchToProps = {
  changeBreakoutType,
  changeBreakoutMaType,
  changeMarketNormallyCheck,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TopInfoStrategy);
